import { render, staticRenderFns } from "./SaleDetailCustomerPage.vue?vue&type=template&id=56b30156&"
import script from "./SaleDetailCustomerPage.vue?vue&type=script&lang=js&"
export * from "./SaleDetailCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetailCustomerPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports